// src/modules/wiring/hooks/useWireAutoSelectBuat.js
//
// H5 Aşama 4 (Phase 2): useComponentWiring'den çıkarıldı.
// operationData.autoSelectBuat varsa otomatik olarak o buat noktasından
// çizim başlatır — kullanıcı manuel "başla" tıklamasına gerek kalmaz.
//
// Kullanım örneği: panel'den priz hattı çekerken, panel exit point'i
// üzerine tıklayan kullanıcı operationData.autoSelectBuat ile sahneye
// yönlendirildiğinde wire çizimi otomatik başlar.

import { useEffect } from 'react';
import * as THREE from 'three';
import { setCommandMessage, setOperationData } from '../../../redux/operationSlice';

/**
 * @param {object} args
 * @param {THREE.Scene} args.scene
 * @param {object} args.base - useBaseWiring API
 * @param {object} args.options - tüketici options (commandType)
 */
export function useWireAutoSelectBuat({ scene, base, options }) {
  useEffect(() => {
    if (
      base.commandType !== options.commandType ||
      !base.operationData?.autoSelectBuat ||
      !base.operationData?.source ||
      base.startRef.current ||
      !base.enabled()
    ) {
      return;
    }

    const buatData = base.operationData.autoSelectBuat;

    // İlk vertex'i buat pozisyonunda oluştur
    const buatVertex = new THREE.Vector3(
      buatData.position.x,
      buatData.position.y,
      buatData.position.z || 0
    );
    base.verticesRef.current = [buatVertex];

    // Source bilgisini snapSourceRef'e kaydet (Vector3 ise serialize et)
    const safeSource = { ...base.operationData.source };
    if (safeSource.position && typeof safeSource.position.x === 'number' && typeof safeSource.position.y === 'number') {
      if (safeSource.position.isVector3) {
        safeSource.position = {
          x: safeSource.position.x,
          y: safeSource.position.y,
          z: safeSource.position.z || 0,
        };
      }
    }
    base.snapSourceRef.current = safeSource;

    // Çizimi başlat
    base.startRef.current = true;
    base.setStep(1);

    // Preview endpoint'i ayarla (mouse hareket edene kadar buat pozisyonunda)
    base.previewEndPointRef.current = buatVertex.clone();
    base.finalPointRef.current = buatVertex.clone();

    // Temp line oluştur
    if (!base.tempLineRef.current) {
      const geometry = new THREE.BufferGeometry().setFromPoints([buatVertex, buatVertex]);
      const material = new THREE.LineBasicMaterial({ color: 0x00ff00 });
      const tempLine = new THREE.Line(geometry, material);
      tempLine.userData = { type: 'tempLine' };
      scene.add(tempLine);
      base.tempLineRef.current = tempLine;
    }

    base.dispatch(setCommandMessage(
      "Buat'tan hat başlatıldı. Sonraki noktaları seçin. Bitirmek için Enter/Space, iptal için ESC."
    ));

    // ✅ ONE-SHOT: autoSelectBuat'ı tüket (temizle). Çizim refs'lerle devam ettiği için
    // bu güvenli; ayrıca finalize sonrası (özellikle source eksik olup confirmPlacement
    // resetOperation'a ulaşmazsa) tekrar tetiklenip hattı yeniden başlatmasını önler.
    base.dispatch(setOperationData({ autoSelectBuat: null }));
  }, [base.commandType, base.operationData, base.enabled, scene, base, options.commandType]);
}

export default useWireAutoSelectBuat;
